// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"89532899","409":"f63f0608","598":"7fc0848b","678":"b3ddeeb1","866":"618aeacb","896":"86e9b7a5","951":"efaad06e","967":"e69f2783"}[chunkId] + ".chunk.css";
};